import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0be5bce8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0be5bce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5bce8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainHeader: require('/opt/iaravia.ru/src/components/main-header.vue').default,InfoMessage: require('/opt/iaravia.ru/src/components/info-message.vue').default,RzDottedLoader: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/dotted-loader/index.vue').default,RzContainer: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/container/index.vue').default,MainFooter: require('/opt/iaravia.ru/src/components/main-footer.vue').default})
